const { localStorage } = require('dibs-browser-storage');
const { cookieJarConstants, getUserId } = require('dibs-cookie-jar');

const isTradeUser = require('../../isTradeUser').default;
const { isPageType, pageTypes: {PAGE_TYPE} } = require('dibs-buyer-layout/src/entries/index');
const enrollmentPromptLoader = require('../../../trade/loyaltyEnrollmentPrompt/enrollmentPromptLoader');
const fetchLoyaltyStatus = require('../../../trade/fetchLoyaltyStatus');
const { tradeLoyaltyStatuses } = require('../../../trade/constants');

const ALLOWED_PAGE_TYPES = [PAGE_TYPE.BROWSE, PAGE_TYPE.HOME, PAGE_TYPE.PDP, PAGE_TYPE.SEARCH];
const LAST_SHOWN_TOKEN = 'tradeLoyaltyPromptLastShown';
const SHOW_COUNT_TOKEN = 'tradeLoyaltyPromptCount';

function viewCount() {
    return localStorage.getItem(SHOW_COUNT_TOKEN) || 0;
}

function markViewInStorage() {
    localStorage.setItem(LAST_SHOWN_TOKEN, Date.now());
    localStorage.setItem(SHOW_COUNT_TOKEN, viewCount() + 1);
}

function isAllowedPageType() {
    return isPageType(ALLOWED_PAGE_TYPES);
}

function seenInLastDay() {
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const lastSeen = localStorage.getItem(LAST_SHOWN_TOKEN) || 0;
    return Date.now() - lastSeen < millisecondsPerDay;
}

function userLoggedIn() {
    return !!getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);
}

module.exports = function tradeLoyaltyPromptRule() {
    if (
        !userLoggedIn() ||
        !isTradeUser() ||
        !isAllowedPageType() ||
        viewCount() > 2 ||
        seenInLastDay()
    ) {
        return Promise.resolve();
    }

    return new Promise(resolve => {
        fetchLoyaltyStatus()
            .then(loyaltyStatus => {
                if (loyaltyStatus !== tradeLoyaltyStatuses.ELIGIBLE) {
                    return resolve();
                }

                return enrollmentPromptLoader
                    .showLoyaltyEnrollmentPrompt({
                        isModal: true,
                        location: 'notification-queue',
                        openFormInNewWindow: true,
                    })
                    .then(() => {
                        markViewInStorage();
                        resolve({
                            success: true,
                            type: 'tradeLoyaltyPrompt',
                        });
                    });
            })
            .catch(() => resolve());
    });
};



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/tradeLoyaltyPromptRule.es.js